import React from 'react';
import SmartPagination from './SmartPagination';

const Pagination = ({ meta, handlePrevPage, handleNextPage, renderPageNumbers, onPageChange }) => {
    // If onPageChange is provided, use SmartPagination
    if (onPageChange) {
        return (
            <SmartPagination
                current_page={meta.current_page}
                last_page={meta.last_page}
                total={meta.total}
                from={meta.from}
                to={meta.to}
                onPageChange={onPageChange}
                className="mt-4"
            />
        );
    }

    // Fallback to old pagination for backward compatibility
    return (
        <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-0">
            {/* Showing Count - Hidden on very small screens */}
            <span className="hidden xs:block text-xs sm:text-sm text-gray-500">
                Showing {meta.from} to {meta.to} of {meta.total} items
            </span>

            {/* Navigation Controls */}
            <div className="flex items-center space-x-1 sm:space-x-2 w-full sm:w-auto justify-center sm:justify-end">
                {/* Previous Button */}
                <button
                    onClick={handlePrevPage}
                    disabled={meta.current_page === 1}
                    className={`
                        px-3 py-1.5 sm:px-4 sm:py-2 
                        text-sm sm:text-base
                        rounded-lg border
                        bg-white/80 backdrop-blur-sm
                        transition-all duration-200
                        ${meta.current_page === 1
                            ? 'opacity-50 cursor-not-allowed'
                            : 'hover:bg-gray-100 active:bg-gray-200'
                        }
                    `}
                >
                    <span className="hidden sm:inline">Previous</span>
                    <span className="sm:hidden">Prev</span>
                </button>

                {/* Page Numbers - Responsive Layout */}
                <div className="flex items-center space-x-1 sm:space-x-2">
                    {renderPageNumbers && renderPageNumbers()}
                </div>

                {/* Next Button */}
                <button
                    onClick={handleNextPage}
                    disabled={meta.current_page === meta.last_page}
                    className={`
                        px-3 py-1.5 sm:px-4 sm:py-2
                        text-sm sm:text-base
                        rounded-lg border
                        bg-white/80 backdrop-blur-sm
                        transition-all duration-200
                        ${meta.current_page === meta.last_page
                            ? 'opacity-50 cursor-not-allowed'
                            : 'hover:bg-gray-100 active:bg-gray-200'
                        }
                    `}
                >
                    Next
                </button>
            </div>

            {/* Mobile Count Display */}
            <span className="xs:hidden text-xs text-gray-500 text-center">
                Showing {meta.from} to {meta.to} of {meta.total} items
            </span>
        </div>
    );
};

export default Pagination;
